import $ from 'jquery';
import PubSub from 'Utils/pub-sub';
import {subscribe} from 'Utils/eventBus';

export default class Sidedrawer {

  constructor(headerSelector) {
    this.header = $(headerSelector);
    this.toggleBtn = $('.js-drawer-toggle');
    this.closeBtn = $('.js-drawer-close');
    this.sideDrawer = $('.js-sidedrawer');
    this.paneContainer = $('.js-sidedrawer_pane-container');
    this.paneItem = $('.js-sidedrawer_item');
    this.paneBackItem = $('.js-sidedrawer_back-item');
    this.mainContent = $('.dcw_main');
    this.loginBox = this.header.find('.dcw_login_wrapper-auth');
    this.handleScroll = this.handleTitleSticky;
    this.lastScroll = this.getScrollPos();
    this.headerTitleMask = $('.dcw_header-title_mask');
    this.headerTitle = $('.dcw_header-title').length > 0 ? 
      $('.dcw_header-title') : null;

    this.paneIndex = $('.js-sidedrawer_item.has-popup.is-active').length;
    this.isSliding = false;
    this.lastActive = [];
    this.isMobile = false;
    this.hideTimeoutId = null;

    this.subHeaderAuth = this.getSubHeader(headerSelector);
    this.authState = this.subHeaderAuth ? 'AUTH' : 'NO_AUTH';

    this.classIsActive = "is-active";
    this.classIsOpen = "is-open";
    this.classIsBlured = "is-blurred";
    this.classIsSticky = "is-sticky";
    this.classIsStickyTitleHeader = ".js--stickyTitleHeader";
    this.classHasPopup = "has-popup";
    this.classJsNoSCroll = "js-no-scroll";

    this.applyDrawerContext();

    this.padContent(this.mainContent);

    if ($(window).width() <= 768) {
      this.slidePane();
    }

    if (this.subHeaderAuth) {
      this.sideDrawer
        .find('.js-sidedrawer_item')
        .filter((index, el) => $(el).hasClass(this.classHasPopup))
        .find('.dcw_main-nav_link')
        .click(e => e.preventDefault());
    }

    this.handleEvents();
    this.handleDrawerToggle();

    subscribe("cms:change-title", params => {
      this.changeTitle(params.title);
    });
  }

  destroy() {
    this.resetPanePosition();
    this.unbindEvents();
    this.toggleBtn.off('click', this._toggleDrawerCallBack);
    this.closeBtn.off('click', this._toggleDrawerCallBack);
    PubSub.unsubscribe('login-search:toggle', this._loginSearchToggleCb);
  }

  resetPanePosition() {
    this.paneIndex = 0;
    this.slidePane();
  }

  changeTitle(newTitle) {
    this.headerTitle.text(newTitle);
  }

  padContent(contentContainer) {
    requestAnimationFrame(() => {
    return this.subHeaderAuth &&
      contentContainer.css(
        'margin-top',
        this.header.outerHeight() +
        this.subHeaderAuth.outerHeight() + 'px'
      ) ||
      contentContainer.css(
        'margin-top',
        this.header.outerHeight() + 'px'
      );

    });
  }

  getSubHeader(headerSelector) {
    return headerSelector === '.js-header-auth' ?
      this.header.find('.dcw_header-title') :
      null;
  }

  applyDrawerContext() {
    let self = this;

    $('.js-sidedrawer_item.has-popup.is-active')
      .each(function (i, item) {
        self.lastActive.push($(item));
      });
  }

  handleEvents() {
    this.paneItem.click(e => this.handleItemClick(e));
    this.paneBackItem.click(e => this.handleBackItemClick(e));
    this._loginSearchToggleCb = () => this.loginBox.toggleClass('is-expanded');

    PubSub.subscribe('login-search:toggle', this._loginSearchToggleCb);

    return this.headerTitle &&
      $(window).scroll(e => {
        this.handleScroll(e);
      });
  }

  unbindEvents() {
    this.paneItem.off('click', this.paneItemClick);
    this.paneBackItem.off('click', this.paneBackItemClick);
  }

  handleDrawerToggle() {
    this._toggleDrawerCallBack = () => this.toggleDrawer();
    this.toggleBtn.click(() => {
      try {
        this.toggleFabVisibility();
      } catch (e) {
        console.error("Error while calling cmsAPI.fab", e);
      }
      this._toggleDrawerCallBack();
    });
    this.closeBtn.click(() => {
      this._toggleDrawerCallBack();
      try {
        this.showFab();
      } catch (e) {
        console.error("Error while calling cmsAPI.fab", e);
      }
    });
  }

  toggleFabVisibility() {
    if (this.sideDrawer.hasClass(this.classIsActive)) {
      this.showFab();
    } else {
      window.cmsAPI.fab.hide();
    }
  }

  showFab() {
    window.cmsAPI.fab.show();
  }

  handleTitleSticky(e) {
    if (this.isScrollingDown()) {
      if (this.getScrollPos() < 74) return;

      requestAnimationFrame(() => {
        this.headerTitle.removeClass(this.classIsSticky);
        this.handleScroll = this.handleTitleHidden;
        this.hideTimeoutId = setTimeout(() =>  {
          this.headerTitleMask.css("display", "none");
        }, 200);
      });
    }

    this.lastScroll = this.getScrollPos();
  }

  handleTitleHidden(e) {
    if (!this.isScrollingDown()) {
      this.cancelTimeout();
      this.headerTitleMask.css("display", "");
      var $titleHeaderArticle = $(this.classIsStickyTitleHeader);

      if ($titleHeaderArticle.length > 0) {
          if ($(window).scrollTop() < $titleHeaderArticle.offset().top - 100) {
              requestAnimationFrame(() => {
                this.headerTitle.addClass(this.classIsSticky);
                this.handleScroll = this.handleTitleSticky;
            });
          }
      } else {
            requestAnimationFrame(() => {
                this.headerTitle.addClass(this.classIsSticky);
            this.handleScroll = this.handleTitleSticky;
        });
      }
    }

    this.lastScroll = this.getScrollPos();
  }

  cancelTimeout() {
    if (!this.hideTimeoutId) return;
    clearTimeout(this.hideTimeoutId);
    this.hideTimeoutId = null;
  }

  getScrollPos() {
    return $(window).scrollTop();
  }

  isScrollingDown() {
    return this.getScrollPos() > this.lastScroll;
  }

  handleItemClick(e) {
    let target = $(e.currentTarget);
    e.stopPropagation();

    if (this.hasPopup(target) &&
        !this.isActive(target) &&
        !this.isSliding) {
      this.setLastActive(target);
      this.paneIndex++;
      this.slidePane();
    }
  }

  handleBackItemClick(e) {
    e.stopPropagation();

    if (!this.isSliding) {
      this.paneIndex--;
      this.slideBack(this.removeLastActive);
    }
  }

  handleResize() {
    let self = this;

    return function () {

      switch (self.isMobile) {

        case true:
          if ($(window).width() >= 768) {
            self.unbindEvents();
            self.isMobile = false;
            self.paneContainer.css(
              'transform', 'translateX(0)'
            );
          } 
        break; 

        case false:
          if ($(window).width() <= 768) {
            self.isMobile = true;
            self.handleEvents();
            self.slidePane();
          }
        break;
      }
    };
  }

  toggleDrawer() {
    this.isMobile = true;
    this.toggleBodyLock();
    this.sideDrawer.toggleClass(this.classIsActive);
    this.toggleBtn.toggleClass(this.classIsOpen);

    if (this.sideDrawer.hasClass(this.classIsActive)) {
        this.toggleBtn.attr("aria-label", window.cmsConstantsLabel.MOBILE_CLOSE_THE_MENU);
    } else {
        this.toggleBtn.attr("aria-label", window.cmsConstantsLabel.MOBILE_OPEN_THE_MENU);
    }
  }

  toggleBodyLock() {
    $(document.body).toggleClass(this.classJsNoSCroll);
    $(document.documentElement).toggleClass(this.classJsNoSCroll);
    this.mainContent.toggleClass(this.classIsBlured);
  }

  slidePane() {
    let transformValue = this.buildTransformValue();
    this.isSliding = true;

    this.resetOnAnimEnd();
    this.paneContainer.css(
      'transform', transformValue  
    );
  }

  slideBack() {
    let transformValue = this.buildTransformValue();
    this.isSliding = true;

    this.resetOnAnimEnd(() => this.removeLastActive());
    this.paneContainer.css(
      'transform', transformValue
    );
  }

  resetOnAnimEnd(callback) {
    let self = this;

    this.paneContainer
      .on('transitionend', function endCb() {
        self.paneContainer.off('transitionend', endCb);
        self.isSliding = false;

        return callback && callback();
    });
  }

  hasPopup(el) {
    return el.hasClass(this.classHasPopup);
  }

  isActive(el) {
    return el.hasClass(this.classIsActive);
  }

  setLastActive(el) {
    el.addClass(this.classIsActive);
    this.lastActive.push(el);
  }

  removeLastActive() {
    let lastActive = this.lastActive.pop();
    lastActive.removeClass(this.classIsActive);
  }

  buildTransformValue() {
    return 'translateX(' +
            this.paneIndex * (-100) +
            '%)';
  }
}


// WEBPACK FOOTER //
// ./src/components/sidedrawer/sidedrawer.js